// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".st2[data-v-77b062e8] {\n  fill: #fff\n}\n.st88[data-v-77b062e8] {\n  fill: #18c3fb\n}\n", ""]);
// Exports
module.exports = exports;
